/*
  BOB 22 Oct 2026 - let shoppers untick GiftLab's "Is this a Gift?" box.
  GiftLab's checkbox only opens its popup (its own untick code is commented out), so once a
  gift message was saved the box stayed ticked for good. Now:
  - Ticking the box: unchanged, GiftLab's popup opens.
  - Unticking a ticked box: the popup does NOT open; the gift options are removed from the cart
    (gift message, sender/recipient, recipient email + date, scheduled delivery, video message,
    the gift text GiftLab wrote into the order note, and any GiftLab gift-wrap / greeting-card /
    add-on items if those features are switched on). All "Is this a Gift?" boxes then untick.
  Loaded from snippets/js-variables.liquid (last 2 lines). Rollback: remove those 2 lines.
*/
(function () {
  if (window.__bobGiftUntick) return;
  window.__bobGiftUntick = true;

  var SEL = '.glproGiftOptionsPageEleCheckbox';
  var ATTRS = [
    'glproGiftMessage', 'RecipientEmail', 'giftMsgEmailDate', 'recipientName', 'senderName',
    'glproScheduleDelivery', 'glproVideoMsgId', 'Video Recorded'
  ];
  var busy = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // GiftLab product variants (only for features that are switched on in the app)
  function giftVariantIds() {
    var s = window.glpro && window.glpro.settings;
    var ids = [];
    if (!s) return ids;
    if (s.giftwrap && s.giftwrap.isGiftWrapEnabled && s.giftwrap.productVariants) {
      s.giftwrap.productVariants.forEach(function (v) { ids.push(Number(v.id)); });
    }
    if (s.greetingCard && s.greetingCard.isGreetingCardEnabled && s.greetingCard.productVariants) {
      s.greetingCard.productVariants.forEach(function (v) { ids.push(Number(v.id)); });
    }
    if (s.giftAddons && s.giftAddons.isGiftAddonsEnabled && s.giftAddons.addOnProducts) {
      s.giftAddons.addOnProducts.forEach(function (p) {
        (p.variants || []).forEach(function (v) { ids.push(Number(v.variantId)); });
      });
    }
    return ids;
  }

  // GiftLab writes "To <name>,\n<message>.\nFrom <name>." into the order note.
  // Remove only that block, keep anything else the shopper wrote.
  function stripGiftNote(note) {
    return (note || '').replace(/(^|\n)To [^\n]*,\n[\s\S]*?\nFrom [^\n]*/g, '').trim();
  }

  function setBoxes(checked) {
    document.querySelectorAll(SEL).forEach(function (el) {
      el.checked = checked;
      if (checked) el.setAttribute('checked', 'checked'); else el.removeAttribute('checked');
    });
  }

  async function removeGiftOptions(box) {
    busy = true;
    try {
      var cart = await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var cartAttrs = cart.attributes || {};
      var body = { attributes: {} };
      ATTRS.forEach(function (k) {
        if (cartAttrs[k] != null && cartAttrs[k] !== '') body.attributes[k] = '';
      });
      var msg = cartAttrs.glproGiftMessage;
      if (msg && cart.note && cart.note.indexOf(msg) > -1) body.note = stripGiftNote(cart.note);

      var ids = giftVariantIds();
      var removedItems = false;
      (cart.items || []).forEach(function (it) {
        if (ids.indexOf(it.variant_id) > -1) {
          body.updates = body.updates || {};
          body.updates[it.key] = 0;
          removedItems = true;
        }
      });

      var res = await fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('cart update ' + res.status);
      var newCart = await res.json();

      if (window.glpro && window.glpro.state) window.glpro.state.cartData = newCart;
      try { sessionStorage.setItem('glproGiftOptionsPageEleCheckbox', 'false'); } catch (e) {}
      setBoxes(false);
      document.querySelectorAll('textarea[name="note"]').forEach(function (t) { t.value = newCart.note || ''; });
      if (removedItems) window.location.reload(); // cart lines and totals changed
    } catch (e) {
      setBoxes(true); // nothing was removed: show the box ticked again
    } finally {
      busy = false;
    }
  }

  // Capture phase, so this runs before GiftLab's own click handler (delegated on document).
  document.addEventListener('click', function (e) {
    var box = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!box || box.tagName !== 'INPUT') return;
    // The browser has already flipped `checked` for this click.
    if (box.checked) return; // shopper is ticking: let GiftLab open its popup
    e.stopImmediatePropagation();
    e.stopPropagation();
    if (busy) { e.preventDefault(); return; }
    removeGiftOptions(box);
  }, true);
})();
